export default "__VITE_ASSET__e9406192__"